import compareDatumWithLimit from '../../../../utils/compareDatumWithLimit';

const getThreatLimit = (heading, index, datum, threatLimits, limits) => {
    const dataLimits = limits.filter((limit) => limit.itemId === `${heading.id}-${index}`);
    const dataThreatLimits = threatLimits.filter((tl) => {
        return dataLimits.find((dl) => tl.id === dl.threatLimitId) ? true : false;
    });

    // Evaluate the datum to all the limits assigned
    const dataLimitsEvaluation = dataLimits
        .map((limit) => {
            const compareResult = compareDatumWithLimit({ datum, operator: limit.operator, limitValue: limit.value });
            if (compareResult) {
                return { ...limit, difference: Math.abs(datum - limit.value) };
            }
            return false;
        })
        .filter((a) => !!a);

    // If evaluation returns two or more limits is true, then
    // find the best limit to apply
    if (dataLimitsEvaluation.length > 1) {
        const bestLimitOption = dataLimitsEvaluation.reduce((previous, current) => {
            // console.log({ previous, current })
            if (previous.difference <= current.difference) {
                return previous;
            }
            return current;
        }, dataLimitsEvaluation[0]);
        const threatLimit = dataThreatLimits.find((threatLimit) => bestLimitOption.threatLimitId === threatLimit.id);

        // console.log({bestLimit: bestLimitOption, threatLimit });
        return threatLimit || threatLimits.find((tl) => tl.default);
    } else {
        if (dataLimitsEvaluation[0]) {
            const threatLimit = dataThreatLimits.find((threatLimit) => dataLimitsEvaluation[0].threatLimitId === threatLimit.id);
            // console.log({ bestLimit: dataLimitsEvaluation[0], threatLimit })
            return threatLimit;
        }
        return threatLimits.find((tl) => tl.default);
    }
};

const getCellThreatLimit = ({ heading, index, threatLimits, limits, value }) => {
    if (threatLimits && limits && value) {
        const number = Number(value);
        const threatLimit = getThreatLimit(heading, index, number, threatLimits, limits);
        return threatLimit;
    } else {
        return null;
    }
};

export default getCellThreatLimit;
